export default __webpack_public_path__ + "static/media/darkOverspeeding.ecc9da53.png";